import { render, staticRenderFns } from "./AddressInfoBox.vue?vue&type=template&id=b89c6a68&"
import script from "./AddressInfoBox.vue?vue&type=script&lang=js&"
export * from "./AddressInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports